import * as React from 'react';
import PropTypes from 'prop-types';
import { useTheme , ThemeProvider} from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@mui/material/Box';
import '../App.css';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Slide from '@mui/material/Slide';
import Collapse from '@material-ui/core/Collapse';
import AddAdmin from "./AddAdmin"; 
import AddAwardee from "./AddAwardee";
import NomSettings from "./NomSettings"; 
import ViewNominations from "./ViewNominations";
import { appInsights } from "../AppInsights";
import { useEffect } from 'react';
import { createTheme } from '@mui/material';
import RegionMinistry from './RegionMinistry';
import { getNominatorMail, getUserGraphId } from './common';
import AddComments from './AddComments';

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any; }) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,

};

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
createStyles({
    root: {
        backgroundColor: '#FFFFFF',
        minHeight:'100vh',
        paddingTop: '40px'
    },
  tabStyle: {
    color:'#00338e',
    fontFamily: 'Barlow !important',
    wordWrap:'break-word',
    minWidth: '7vw',
    minHeight: '10vh',
    "&.MuiButtonBase-root.MuiTab-root": {
      minHeight: '25vh',
      height: '11vh'
    },
    "&.Mui-selected": {
      backgroundColor:'#F3F3F3'
   },
  },
  [theme.breakpoints.down(700)]: {
    tabStyle: {
      color:'#00338e',
      fontFamily: 'Barlow !important',
      wordWrap:'break-word',
      minWidth: '2vw',
      minHeight: '8vh',
      fontSize: '10px',
      "&.MuiButtonBase-root.MuiTab-root": {
        minHeight: '2vh',
        height: '1vh'
      },
      "&.Mui-selected": {
        backgroundColor:'#F3F3F3'
     },
    },  
  },
  tabpanelRoot: {
    backgroundColor:'#F3F3F3',
    width:'100%',
    minWidth: '70vw'
  },
  indicator:{
    backgroundColor:'#00338e',
    width:'4px'
  }
}),
  );


export default function VerticalTabs() {

  useEffect(()=>{appInsights.trackPageView({name: "AdminPageLoaded",properties:{CorrelationId:getcorrelationId(),AccountIdentifier: getUserGraphId()}})})
  
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue);
  };

    const customTheme = createTheme({
        palette: {
          primary: {
            light: "#42c2f5",
            main: "#00338e",
            dark: "#778899",
            contrastText: "#fff"
          }
        }
      });

  const classes = useStyles();

  return (
    <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex'}}>
      
    <ThemeProvider theme={customTheme}>
    
      <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          textColor="primary"
          variant="fullWidth"
          className={classes.root}
          classes={{indicator:classes.indicator}} 
        >
         
        <Tab label={<span>Add Admin</span>} className={classes.tabStyle} {...a11yProps(0)} />
        <Tab label={<span>Add System Awardee</span>} className={classes.tabStyle} {...a11yProps(1)} />
        <Tab label={<span>View Nominations</span>} className={classes.tabStyle} {...a11yProps(2)} />
        <Tab label={<span>Add Reviewer Notes<br></br>To Nominations</span>} className={classes.tabStyle} {...a11yProps(3)} />
        <Tab label={<span>Update Region-Ministry</span>} className={classes.tabStyle} {...a11yProps(4)} />
        <Tab label={<span>Settings</span>} className={classes.tabStyle} {...a11yProps(5)} />
        
      </Tabs>
      <TabPanel value={value} index={0} className={ classes.tabpanelRoot}>
        <AddAdmin/>
      </TabPanel>
      <TabPanel value={value} index={1} className={ classes.tabpanelRoot}>
        <AddAwardee/>
      </TabPanel>
      <TabPanel value={value} index={2} className={ classes.tabpanelRoot}>
        <ViewNominations/>
      </TabPanel>
      <TabPanel value={value} index={3} className={ classes.tabpanelRoot}>
        <AddComments/>
      </TabPanel>
      <TabPanel value={value} index={4} className={ classes.tabpanelRoot}>
        <RegionMinistry/>
      </TabPanel>
      <TabPanel value={value} index={5} className={ classes.tabpanelRoot}>
        <NomSettings/>
      </TabPanel>
      </ThemeProvider> 
      
        
      </Box>
  );
}


